"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelHighchartsCalculations = void 0;
const highcharts_1 = __importDefault(require("highcharts"));
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const FunnelChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/model/FunnelChartSettingsJSONModel");
const lodash_1 = __importDefault(require("lodash"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const NumberUtils_1 = require("src/hello_assets/src/util/NumberUtils");
const ICEventQueryUtil_1 = require("src/hello_assets/src/util/ICEventQueryUtil");
const CommonTypesI18N_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesI18N");
const HighchartsOptionsProviderCommon_1 = require("src/hello_assets/src/util/HighchartsOptionsProviderCommon");
const optionsForClassic = (params) => {
    const title = "Funnel";
    const series = [];
    const mainSectionData = [];
    const emptySectionData = [];
    const offSectionData = [];
    const request = params.request;
    const response = params.response;
    const responseClassic = lodash_1.default.cloneDeep(response.classic);
    let maxValue = 0;
    if (!lodash_1.default.isEmpty(responseClassic)) {
        const firstStepIndex = 0;
        const totalUniques = responseClassic[firstStepIndex];
        let previousData = totalUniques;
        lodash_1.default.each(responseClassic, function (nextStepData) {
            // if (nextStepIndex >= firstStepIndex) {
            mainSectionData.push(nextStepData);
            const nextOffDataValue = previousData - nextStepData;
            const nextEmptyValue = (totalUniques - (nextStepData + nextOffDataValue));
            emptySectionData.push(nextEmptyValue);
            offSectionData.push(nextOffDataValue);
            previousData = nextStepData;
            // }
        });
        maxValue = responseClassic[firstStepIndex];
        // console.log("emptySectionData", emptySectionData);
        // console.log("offData", offData);
        // console.log("jsonResponse.data", response.classic);
        series.push({
            type: "column",
            data: emptySectionData,
            color: 'rgba(255, 255, 255, 0.0)',
            custom: { type: "empty" },
        });
        series.push({
            type: "column",
            data: offSectionData,
            cursor: 'pointer',
            color: 'url(#custom-pattern)',
            custom: { type: "dropOff" }
        });
        series.push({
            type: "column",
            data: mainSectionData,
            cursor: 'pointer',
            color: '#00A7CF',
            custom: { type: "main" }
        });
        const options = {
            exporting: {
                filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
            },
            chart: {
                type: "column",
            },
            defs: {
                patterns: [{
                        'id': 'custom-pattern',
                        'path': {
                            d: 'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9',
                            fill: '#99DCEC',
                            stroke: '#CCEDF5',
                            strokeWidth: 3
                        }
                    }]
            },
            title: { text: title },
            xAxis: {
                type: 'category',
                categories: ClassicUtil.categories(request.returnEvents)
            },
            tooltip: {
                followPointer: true,
                formatter: function () {
                    const name = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariant(request.returnEvents[this.point.x], { truncateLength: 30 });
                    const count = this.y;
                    const value = maxValue > 0 ? count / maxValue : 0;
                    const valuePercent = NumberUtils_1.NumberUtils.formatNumericValue(value * 100, 2);
                    const total = maxValue;
                    const custom = this.series.options.custom;
                    if (custom === null || custom === void 0 ? void 0 : custom.type) {
                        switch (custom.type) {
                            case "empty": {
                                return false;
                            }
                            case "dropOff": {
                                return `<b>${name}</b><br/>Drop-off: <b>${valuePercent}%</b> (${count} of ${total})`;
                            }
                            case "main": {
                                return `<b>${name}</b><br/>Converted: <b>${valuePercent}%</b> (${count} of ${total})`;
                            }
                        }
                    }
                    return false;
                }
            },
            yAxis: {
                min: 0,
                maxPadding: 0,
                title: {
                    text: ''
                },
                stackLabels: {
                    enabled: false,
                    style: {
                        fontWeight: 'bold'
                    }
                },
                labels: {
                    formatter: function () {
                        return this.value + "%";
                    }
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    states: {
                        inactive: {
                            opacity: 1
                        }
                    }
                },
                column: {
                    stacking: 'percent',
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function () {
                            const custom = this.series.options.custom;
                            if ((custom === null || custom === void 0 ? void 0 : custom.type) === "main") {
                                return `<span style="color:white; font-weight: bold; text-shadow: 0 1px black; stroke-width: 1px">${this.y}</span>`;
                            }
                            else {
                                return "";
                            }
                        }
                    },
                }
            },
            series: series,
        };
        return options;
    }
    return {};
};
const optionsForOvertime = (params) => {
    const title = "Funnel Over Time";
    const request = params.request;
    const response = params.response;
    const series = [];
    const tickInterval = DateTimeFacade_1.DAY_IN_MILLIS;
    //1st element is "Session"
    //2nd element is the first from "returnEvents"
    if (lodash_1.default.size(response.overtime) > 1) {
        const intervalStartMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(response.intervalStartTimeSec * 1000).startOf("day");
        const intervalStartTimeMillis = intervalStartMoment.valueOf();
        const firstStepHistoryData = response.overtime[0];
        lodash_1.default.each(response.overtime, function (nextHistoryData, stepIndex) {
            const historyDataStartFrom = 1;
            if (stepIndex >= historyDataStartFrom) {
                const historyDataPercent = [];
                lodash_1.default.each(nextHistoryData, function (periodValue, periodIndex) {
                    if (firstStepHistoryData[periodIndex] > 0 && periodValue > 0) {
                        const percentValue = periodValue / firstStepHistoryData[periodIndex] * 100;
                        historyDataPercent.push(parseFloat(percentValue.toFixed(2)));
                    }
                    else {
                        historyDataPercent.push(0);
                    }
                });
                const seriesColor = (0, HighchartsCalculationsCommonUtils_1.getSeriesColorFromGlobalColors)(stepIndex);
                series.push({
                    pointInterval: tickInterval,
                    pointStart: intervalStartTimeMillis,
                    type: 'spline',
                    name: OvertimeUtil.seriesNameAsStepName(request.returnEvents, stepIndex),
                    data: historyDataPercent,
                    color: seriesColor,
                    custom: {
                        historyDataIndex: stepIndex
                    },
                });
            }
        });
        const options = {
            chart: { zoomType: "x", },
            title: { text: title },
            exporting: {
                filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
            },
            xAxis: {
                dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
                minTickInterval: tickInterval,
                type: 'datetime',
            },
            yAxis: {
                min: 0,
                maxPadding: 0,
                title: { text: '' },
                stackLabels: {
                    enabled: true,
                    style: { fontWeight: 'bold' }
                },
                labels: {
                    formatter: function () {
                        return `${this.value}%`;
                    }
                }
            },
            tooltip: {
                useHTML: true,
                shared: true,
                formatter: function () {
                    const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(this.x).valueOf());
                    let pointsTableHTML = HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableOpen();
                    lodash_1.default.each(this.points, ctx => {
                        const custom = ctx.series.options.custom;
                        const historyDataIndex = custom.historyDataIndex;
                        const stepName = `Step ${historyDataIndex}`;
                        const pointValue = ctx.y;
                        const tooltipValuePostfix = "%";
                        pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, stepName, pointValue, tooltipValuePostfix);
                    });
                    pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableClose();
                    const headerHTML = `<span>${date}</span><br/>`;
                    return `${headerHTML}${pointsTableHTML}`;
                }
            },
            series: series,
        };
        return options;
    }
    return {};
};
const optionsFor = (params) => {
    // console.log("optionsFor: params", params);
    if (params.request !== undefined && params.response !== undefined) {
        const requiredParams = {
            request: params.request,
            response: params.response,
            chartType: params.chartType,
        };
        switch (params.chartType) {
            case FunnelChartSettingsJSONModel_1.ChartType.classic:
                return optionsForClassic(requiredParams);
            case FunnelChartSettingsJSONModel_1.ChartType.overtime:
                return optionsForOvertime(requiredParams);
        }
    }
    return {};
};
exports.FunnelHighchartsCalculations = {
    optionsFor: optionsFor
};
////////////////////////////////////////////////
// Private
////////////////////////////////////////////////
const ClassicUtil = {
    categories: (returnEvents) => lodash_1.default.map(returnEvents, v => ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariant(v, { truncateLength: 30 }) || ""),
};
const OvertimeUtil = {
    seriesNameAsStepName: (returnEvents, stepIndex) => {
        console.log("seriesNameAsStepName", { returnEvents, stepIndex });
        const parts = [];
        for (let i = 0; i < (stepIndex + 1); i++) {
            parts.push(ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariant(returnEvents[i], { truncateLength: 20 }) || "");
        }
        const sequenceOfEvents = parts.join(` ${CommonTypesI18N_1.CommonTypesI18N.constants.highchartsArrow} `);
        return `Step ${stepIndex}: ${sequenceOfEvents}`;
    },
};
